(function () {
  'use strict';

  var PRODUCT_PRICE_UPDATE_DELAY = 100;
  var WSAIO_READY_CHECK_INTERVAL = 50;
  var WSAIO_READY_TIMEOUT = 10000;

  function getQuantityInput(wrapper) {
    var productSection =
      wrapper.closest('.js-product') ||
      wrapper.closest('.product-info') ||
      document;

    return (
      productSection.querySelector('input[name="quantity"]') ||
      productSection.querySelector('.quantity__input') ||
      productSection.querySelector('[data-quantity-input]') ||
      document.querySelector('input[name="quantity"]') ||
      document.querySelector('.quantity__input') ||
      document.querySelector('[data-quantity-input]')
    );
  }

  function updateSavingsBar(wrapper) {
    var fill = wrapper.querySelector('.swf-progress-fill');
    var message = wrapper.querySelector('.swf-savings-message');
    var tiers = wrapper.querySelectorAll('.swf-tier');

    if (!fill || !message) return;

    var input = getQuantityInput(wrapper);
    var quantity = input ? parseInt(input.value, 10) || 1 : 1;

    var isLimited =
      wrapper.dataset.limitedMultibuy === 'true';

    var progress = 0;
    var text = isLimited
      ? 'Add 1 more item to unlock 5% savings'
      : 'Add 1 more item to unlock 3% savings';

    if (isLimited) {
      if (quantity >= 2) {
        progress = 100;
        text = "You're saving 5%";
      }
    } else if (quantity >= 8) {
      progress = 80;
      text = "Maximum savings unlocked – you're saving 10%";
    } else if (quantity >= 4) {
      progress = 50;

      if (quantity === 7) {
        text = 'Add 1 more item to unlock 10% savings';
      } else {
        text = "You're saving 5%";
      }
    } else if (quantity >= 2) {
      progress = 20;

      if (quantity === 3) {
        text = 'Add 1 more item to unlock 5% savings';
      } else {
        text = "You're saving 3%";
      }
    }

    fill.style.width = progress + '%';
    message.textContent = text;

    tiers.forEach(function (tier) {
      var requiredQuantity = parseInt(
        tier.dataset.tier,
        10
      );

      tier.classList.toggle(
        'active',
        quantity >= requiredQuantity
      );
    });
  }

  function updateAllSavingsBars() {
    document
      .querySelectorAll('[data-swf-savings]')
      .forEach(updateSavingsBar);
  }

  function delayedUpdate() {
    window.setTimeout(updateAllSavingsBars, 100);
  }

  function isMainProductQuantityInput(input) {
    if (!(input instanceof Element)) return false;

    if (
      input.closest(
        'cart-drawer, #cart, .cart-drawer, [data-cart-drawer]'
      )
    ) {
      return false;
    }

    return Boolean(
      input.closest('form.js-product-form-main')
    );
  }

  function getInputQuantity(input) {
    if (input.tagName === 'SELECT') {
      return input.options[input.selectedIndex].value;
    }

    return input.value;
  }

  function installFastProductPriceUpdate() {
    var startedAt = Date.now();

    function attemptInstall() {
      var handleQty = window.HandleQty;
      var wholesale = window.WSAIO;

      if (
        !handleQty ||
        typeof handleQty.change !== 'function' ||
        !wholesale ||
        typeof wholesale.Volume_disocunted_price !== 'function'
      ) {
        if (Date.now() - startedAt < WSAIO_READY_TIMEOUT) {
          window.setTimeout(
            attemptInstall,
            WSAIO_READY_CHECK_INTERVAL
          );
        }

        return;
      }

      if (handleQty.change.wwfsProductPageFastUpdate) {
        return;
      }

      var originalChange = handleQty.change.bind(handleQty);
      var productTimers = new WeakMap();

      function wwfsFastProductChange(input) {
        if (!isMainProductQuantityInput(input)) {
          return originalChange(input);
        }

        var existingTimer = productTimers.get(input);

        if (existingTimer) {
          window.clearTimeout(existingTimer);
        }

        var timer = window.setTimeout(function () {
          productTimers.delete(input);

          if (
            window.WSAIO &&
            typeof window.WSAIO.Volume_disocunted_price ===
              'function'
          ) {
            window.WSAIO.Volume_disocunted_price(
              getInputQuantity(input)
            );
          }
        }, PRODUCT_PRICE_UPDATE_DELAY);

        productTimers.set(input, timer);
      }

      wwfsFastProductChange.wwfsProductPageFastUpdate = true;
      handleQty.change = wwfsFastProductChange;
    }

    attemptInstall();
  }

  function initialiseSavingsBars() {
    updateAllSavingsBars();
    installFastProductPriceUpdate();

    document.addEventListener(
      'input',
      function (event) {
        if (
          event.target.matches('input[name="quantity"]') ||
          event.target.matches('.quantity__input') ||
          event.target.matches('[data-quantity-input]')
        ) {
          updateAllSavingsBars();
        }
      }
    );

    document.addEventListener(
      'change',
      updateAllSavingsBars
    );

    document.addEventListener(
      'click',
      delayedUpdate
    );

    document.addEventListener(
      'shopify:section:load',
      delayedUpdate
    );

    document.addEventListener(
      'variant:change',
      delayedUpdate
    );

    document.addEventListener(
      'product:variant-change',
      delayedUpdate
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initialiseSavingsBars,
      { once: true }
    );
  } else {
    initialiseSavingsBars();
  }
})();